import React from "react";
import { SafetyCertificateFilled, ShopFilled,PieChartFilled  } from "@ant-design/icons";
import TrainingPage from "PlatForms/OrgLMS/Dashboards/Learner/Trainings";
import TrainingGroup from "PlatForms/OrgLMS/Dashboards/Learner/TrainingGroup/TrainingGroup";
import { Chat } from "@mui/icons-material";
import StartChat from "PlatForms/Dashboards/Chat/Chat";
import ChatBadge from "PlatForms/Dashboards/Chat/ChatBadges/ChatBadge";
import LearnerDashboard from "PlatForms/OrgLMS/Dashboards/Learner/LandingPage/LearnerDashboard";
import TrainingCertificates from "PlatForms/OrgLMS/Dashboards/Learner/TrainingCertificate/TrainingCertificates";
import PersonalityAssessmentForm from "PlatForms/OrgLMS/Dashboards/Learner/PesonalityAssessment/PersonalityAssessmentForm";
import ProtectedPage from "Common/Components/ProtectedPage";


const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "learner-dashboard",
    route: "/learner-dashboard",
    icon: <ShopFilled size="12px" />,
      component: (
          <ProtectedPage navigateTo="/learner-profile">
            <LearnerDashboard />
          </ProtectedPage>
        ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: <ChatBadge dataKey="message" name="Messaging" />,
    key: "messaging",
    route: "/messaging",
    icon: <Chat size="12px" />,
      component: (
          <ProtectedPage navigateTo="/learner-profile">
            <StartChat />
          </ProtectedPage>
        ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Training",
    key: "training",
    route: "/training",
    icon: <ShopFilled size="12px" />,
      component: (
          <ProtectedPage navigateTo="/learner-profile">
            <TrainingPage />
          </ProtectedPage>
        ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Training Group",
    key: "training-group",
    route: "/training-group",
    icon: <ShopFilled size="12px" />,
      component: (
          <ProtectedPage navigateTo="/learner-profile">
            <TrainingGroup/>
          </ProtectedPage>
        ),
  
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Training Certificate",
    key: "training-certificate",
    route: "/training-certificate",
    icon: <SafetyCertificateFilled size="12px" />,
      component: (
          <ProtectedPage navigateTo="/learner-profile">
            <TrainingCertificates/>
          </ProtectedPage>
        ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Personality Assessment",
    key: "Personality Assessment",
    route: "/personality-assessment",
    icon: <PieChartFilled  size="12px" />,
      component: (
          <ProtectedPage navigateTo="/learner-profile">
            <PersonalityAssessmentForm />
          </ProtectedPage>
        ),
    noCollapse: true,
  },
];

export default routes;
